export const customTranslation = {
    tooltips: {
      placeMarker: "کلیک برای جانمایی نشان",
      firstVertex: "اولین نقطه را رسم کنید",
      continueLine: "نقطه بعدی را رسم کنید",
      finishLine: "جهت پایان روی آخرین نقطه موجود مجددا کلیک کنید",
      finishPoly: "با کلیک روی نقطه اول، محدوده رسم خواهد شد",
      finishRect: "کلیک برای پایان",
      startCircle: "کلیک برای رسم مرکز دایره",
      finishCircle: "کلیک برای پایان رسم دایره",
      placeCircleMarker: "کلیک برای رسم نشان دایره",
      placeText: "کلیک برای نوشتن متن",
    },
    actions: {
      finish: "تایید",
      cancel: "لفو",
      removeLastVertex: "حذف آخرین نقطه",
    },
    buttonTitles: {
      drawMarkerButton: "درج نشان",
      drawPolyButton: "رسم چندضلعی",
      drawLineButton: "رسم خط",
      drawCircleButton: "رسم دایره",
      drawRectButton: "رسم چهارضلعی",
      editButton: "ویرایش لایه‌ها",
      dragButton: "جابجایی لایه‌ها",
      cutButton: "برش لایه‌ها",
      deleteButton: "حذف لایه‌ها",
      drawCircleMarkerButton: "رسم نشان دایره",
      snappingButton: "نشانگر را به لایه‌ها و رئوس دیگر بکشید",
      pinningButton: "رئوس مشترک را با هم پین کنید",
      rotateButton: "چرخش لایه",
      drawTextButton: "رسم متن",
    },
  };

export const regFieldControls = {
  position: "topright",
  drawCircleMarker: false,
  drawText: false,
  drawPolyline: false,
  drawMarker: false,
  drawRectangle: false,
  drawCircle: false,
  cutPolygon: false,
  rotateMode: false,
  dragMode: false
}

export const growingSeasonControls = {
  position: "topright",
  drawCircleMarker: false,
  drawText: false,
  drawPolyline: false,
  drawMarker: false,
  drawRectangle: false,
  drawCircle: false,
  cutPolygon: false,
  rotateMode: false,
  dragMode: false,
}

export const weatherStationControls = {
  position: "topright",
  drawMarker: false,
  drawPolygon: false,
  drawCircleMarker: false,
  drawText: false,
  drawPolyline: false,
  drawRectangle: false,
  drawCircle: false,
  cutPolygon: false,
  rotateMode: false,
  dragMode: false,
  removalMode: false,
  editMode: false
}



export const fieldViewControls = {
  position: "topright",
  drawMarker: false,
  drawPolygon: false,
  drawCircleMarker: false,
  drawText: false,
  drawPolyline: false,
  drawRectangle: false,
  drawCircle: false,
  cutPolygon: false,
  rotateMode: false,
  dragMode: false,
  removalMode: false,
  editMode: false
}

export const waterSourceControls = {
  position: "topright",
  drawMarker: false,
  drawPolygon: false,
  drawCircleMarker: false,
  drawText: false,
  drawPolyline: false,
  drawRectangle: false,
  drawCircle: false,
  cutPolygon: false,
  rotateMode: false,
  dragMode: false,
  removalMode: false,
  editMode: false
}

export const poolsControls = {
  position: "topright",
  drawMarker: false,
  drawPolygon: false,
  drawCircleMarker: false,
  drawText: false,
  drawPolyline: false,
  drawRectangle: false,
  drawCircle: false,
  cutPolygon: false,
  rotateMode: false,
  dragMode: false,
  removalMode: false,
  editMode: false
}
